import { AccordionItem } from 'library/components/controls/accordion/AccordionItem';
import { IsExternal } from 'library/types';

import { ReleaseNoteAccordionContent } from './ReleaseNoteAccordionContent';
import ReleaseNoteHeader from './ReleaseNoteHeader';
import { ReleaseNoteListProps } from './types';

interface ReleaseNoteAccordionProps extends ReleaseNoteListProps, IsExternal {}

export const ReleaseNoteAccordion = ({
	releaseNote,
	isExternal,
}: ReleaseNoteAccordionProps) => {
	const { id } = releaseNote;

	return (
		<AccordionItem
			accordionName={id.toString()}
			HeaderComponent={<ReleaseNoteHeader releaseNote={releaseNote} />}
			key={id}>
			<ReleaseNoteAccordionContent id={id} isExternal={isExternal} />
		</AccordionItem>
	);
};
